import contactUs from "./contactUs";
import subscribe from "./subscribe";
import getPosts from "./getPosts";
import login from "./login";
import sendResetPasswordEmail from "./sendResetPasswordEmail";
import resetPassword from "./resetPassword";
import register from "./register";
import createPayment from "./createPayment";

export default class Api {
  static BASE_URL = "/wp-json/api";

  static fetch = async (options) => {
    const { endpoint, method = "GET", body, headers, okStatus = 200 } = options;

    let response;

    headers["X-WP-Nonce"] = window.saee.nonce;

    try {
      response = await fetch(`${Api.BASE_URL}/${endpoint}`, {
        method: method.toUpperCase(),
        body: body,
        headers: headers,
        credentials: "same-origin",
      });      
    } catch (e) {
      throw await Api.errorHandling(null, e);
    }

    if (response.status !== okStatus) {
      throw await Api.errorHandling(response);
    }

    return response;
  };

  static errorHandling = async (response, error = null) => {
    if (!response) {
      return {
        code: "internet_connection",
        message:
          window.saee.copy[
            "Please check your internet connection and try again"
          ],
        validation: [],
        error,
      };
    }

    if (response.status === 500) {
      return {
        code: "internal_server_error",
        message:
          window.saee.copy[
            "Something went wrong while handling your request, please try again"
          ],
        validation: [],
        response,
      };
    } else if (response.status === 400) {
      let data = await response.json();
      return {
        code: "bad_request",
        message: data.message,
        validation: [],
        response,
      };
    }

    const body = await response.json();
    const errorMessage = body.message;
    const validation = body.validation ?? [];
    return {
      code: "error",
      message: window.saee.copy["Something went wrong"],
      validation: validation,
      response: { message: errorMessage ?? false, ...response },
    };
  };

  static contactUs = contactUs(Api.fetch);
  static subscribe = subscribe(Api.fetch);
  static getPosts = getPosts(Api.fetch);
  static login = login(Api.fetch);
  static sendResetPasswordEmail = sendResetPasswordEmail(Api.fetch);
  static resetPassword = resetPassword(Api.fetch);
  static register = register(Api.fetch);
  static createPayment = createPayment(Api.fetch);
}
